// extracted by mini-css-extract-plugin
module.exports = {"main":"Legal_main__1PQ3Y","content":"Legal_content__3B8l-"};